import { useCallback } from 'react';
import { DirectionType, SortParamsType } from 'types';

export const useSorting = <T extends Required<SortParamsType>>(
  searchParams: T,
  setSearchParams: (params: Partial<T>) => void
) => {
  const getSortDirection = useCallback(
    (column: string) => {
      const { sort, direction } = searchParams;
      const index = sort.findIndex((item) => item === column);
      if (index === -1) return null;
      return direction[index] === 'ASC' ? 'ASC' : 'DESC';
    },
    [searchParams]
  );

  const handleSorting = useCallback(
    (column: string, direction?: DirectionType) => {
      const { sort, direction: directionParam } = searchParams;

      const newSort = [...sort];
      const newDirection = [...directionParam];

      const index = newSort.findIndex((item) => item === column);
      if (index !== -1) {
        newSort.splice(index, 1);
        newDirection.splice(index, 1);
      }
      if (direction) {
        newSort.push(column);
        newDirection.push(direction);
      }

      setSearchParams({ sort: newSort, direction: newDirection } as Partial<T>);
    },
    [searchParams, setSearchParams]
  );

  return { getSortDirection, handleSorting };
};
